<div class="lcl-quote-container">
  <h3 class="lcl-quote-header-text">{{ "REQUEST_SHIPPING_QUOTE" | translate }}</h3>

  <div class="lcl-quote-card">
    <div class="lcl-quote-header">
      <app-lcl-create-quote-from-to-updated
        [departurePortFc]="departurePortFc"
        [arrivalPortFc]="arrivalPortFc"
        [isSubmitted]="isSubmitted"
        (onSelectFromPort)="onSelectFromPort($event)"
        (onSelectToPort)="onSelectToPort($event)"
        (onSearch)="onStartSearch()"
        (onClear)="onStartSearch()"
      ></app-lcl-create-quote-from-to-updated>
    </div>

    <div class="lcl-quote-body">
      <div class="lcl-quote-body-warning" *ngIf="isShowRouteWarning">
        <lcl-route-warning
          [customerNotesFc]="customerNotesFc"
          [isWithForm]="true"
          [isButtonDisabled]="customerNotesFc.disabled"
          [isMobile]="isMobile"
          (close)="onCloseRouteWarning()"
          (notesSubmit)="onNotesSubmit()"
        ></lcl-route-warning>
      </div>

      <h3 class="lcl-quote-body-title-mobile">{{ "LCL_SHIPMENT.QUOTE.CREATE.WHAT_ARE_YOU_SHIPPING" | translate }}</h3>

      <app-lcl-create-quote-packages
        #packagesView
        [isInCard]="false"
        [isQuoteCreate]="true"
        [isMobile]="isMobile"
        [packagesFormArray]="packagesFormArray"
        (addPackage)="addPackage()"
        (confirmPackage)="confirmPackage()"
        (removePackage)="removeQuote($event)"
      ></app-lcl-create-quote-packages>

      <div class="d-xl-none">
        <button type="button" class="lcl-quote-body-add-package-mobile" *ngIf="!isFormEdited" (click)="addLoadDetails()">
          <div class="icon-plus-container">
            <icon-plus></icon-plus>
          </div>
          {{ "ADD_LOAD_DETAILS" | translate }}
        </button>

        <div class="lcl-quote-body-packages-totals" [ngClass]="{ 'd-none': isFormEdited || !totalUnits }">
          <p class="lcl-quote-body-packages-totals-header">{{ "LABELS.TOTALS" | translate }}: {{ totalUnits }}</p>

          <span class="lcl-quote-body-packages-totals-sub-header">{{ "LABELS.WEIGHT" | translate }}</span>
          <p class="lcl-quote-body-packages-totals-value">{{ totalWeight }} {{ "WEIGHT_UNIT.KG" | translate }}</p>

          <span class="lcl-quote-body-packages-totals-sub-header">{{ "LABELS.VOLUME" | translate }}</span>
          <p class="lcl-quote-body-packages-totals-value">{{ totalValue }} {{ "LENGTH_UNIT.CBM" | translate }}</p>
        </div>
      </div>
    </div>

    <div class="lcl-quote-footer">
      <div class="lcl-quote-footer-notification">
        <img src="assets/icons/icon_attention_sm.svg" />

        <div
          class="lcl-quote-footer-notification-text"
          [innerHTML]="'EEZYIMPORT_NOT_SUPPORT_TRANSPORTATION_OF_RESTRICTED_COMMODITIES' | translate"
        ></div>
      </div>

      <div class="lcl-quote-footer-submit">
        <button class="btn btn-primary" [disabled]="isShowRouteWarning" (click)="onSubmit()">
          <div class="d-flex justify-content-center justify-content-xl-between align-items-center">
            {{ "BUTTON.GET_A_QUOTE" | translate }}

            <img class="ml-2" src="assets/icons/icon_arrow_right_sm_white.svg" />
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
